export enum ToolEnum {
    Select = 'Select',
    Hide = 'Hide',
    Paint = 'Paint',
    Label = 'Label',
    Isolate = 'Isolate',
    Fade = 'Fade',
    Position = 'Position',
    Quiz = 'Quiz'
}
